export enum DataCrafterTemplateStatus {
    Draft = 'Draft',
    Active = 'Active',
    Archived = 'Archived'
}
